import type { SettingsTranslations } from "../en/Settings";
import type { TranslationShape } from "../../store/types";

export const settingsEs: TranslationShape<SettingsTranslations> = {
  pageTitle: "Configuración",
  pageSubtitle: "Administra la configuración del merchant y los reportes de PowerBI.",
  createWorkspace: "Crear Workspace",
  language: "Idioma",
  loading: "Cargando configuración...",
  loadFailed: "No se pudo cargar la configuración...",
  enabled: "Habilitado",
  disabled: "Deshabilitado",
  notSet: "Sin asignar",
  createWorkspaceFirst: "Crea primero el workspace",
  missingReport: "Reporte no disponible ({{value}})",
  jdaBaselineImport: "Importar Línea Base de JDA",
  toasts: {
    saved: "¡Los cambios de configuración se han guardado!",
    workspaceCreated: "¡El workspace de PowerBI ha sido creado!",
  },
  booleanSettings: {
    productRanking: {
      label: "Ranking de Productos",
      description:
        "Habilita los controles de ranking de productos usados en los flujos de merchflow.",
    },
    maxUnits: {
      label: "Unidades Máximas",
      description:
        "Habilita el comportamiento de unidades máximas donde aplique en los flujos de planificación.",
    },
    spaceMix: {
      label: "Mezcla de Espacio",
      description: "Expone la funcionalidad de mezcla de espacio en la experiencia de merchflow.",
    },
    dosPercentage: {
      label: "Mostrar DOS como Porcentaje",
      description: "Muestra los días de suministro usando formato de porcentaje.",
    },
    jdaImport: {
      label: "Importar Línea Base de JDA",
      description:
        "Muestra la acción de importación de línea base de JDA usada para exportaciones de datos del retailer.",
    },
    shelfWeight: {
      label: "Peso de Estante",
      description:
        "Envía los pesos de producto al optimizador, habilita la pestaña de reglas de peso y muestra la carga y sobrecarga de estantes en los planogramas.",
    },
  },
  reportSettings: {
    basePog: {
      label: "Reporte POG Base",
      description: "Usado por el punto de entrada del reporte POG base.",
    },
    storePog: {
      label: "Reporte POG por Tienda",
      description: "Usado por el punto de entrada del reporte de integridad de todas las tiendas.",
    },
    singleStorePog: {
      label: "Reporte POG de Tienda Individual",
      description: "Usado por el punto de entrada del reporte de integridad de una sola tienda.",
    },
    categoryRangeReview: {
      label: "Reporte de Revisión de Rango por Categoría",
      description: "Usado por el punto de entrada del reporte de revisión de rango por categoría.",
    },
  },
};
